import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Rahul Kothekar',
      location: 'Home Owner, Nagpur',
      text: `ERA Interior exceeded all expectations. Their design ideas were modern, smart, and aligned perfectly with our needs. The POP ceiling, wooden work, and feature walls completely elevated our flat’s look. Highly recommended if you want quality and class under one roof.`,
    },
    {
      name: 'Pramod Kumar Roy',
      location: 'Flat Owner - Mihan, Nagpur',
      text: `I couldn't be happier with the transformation ERA Interior brought to our home. From the first meeting to the final touches, their team was attentive, creative, and professional. They truly understood our style and gave us a space that feels luxurious yet comfortable.`,
    },
  ];

  return (
    <div className="our-testimonials">
      <div className="container-fluid">
        <div className="row no-gutters">
          {/* Image Column */}
          <div className="col-lg-6">
            <div className="our-testimonials-image">
              <figure className="image-anime">
                <img src="images/testimonial-img.jpg" alt="" />
              </figure>
            </div>
          </div>

          {/* Testimonials Column */}
          <div className="col-lg-6">
            <div className="our-testimonial-content">
              <div className="section-title">
                <h3 className="wow fadeInUp" style={{ fontSize: 25 }}>
                  client testimonials
                </h3>
                <h2 className="text-anime-style-2" data-cursor="-opaque">
                  Trusted by thousand of <span>people &amp; companies.</span>
                </h2>
              </div>

              {/* Swiper Slider */}
              <div className="testimonial-slider">
                <Swiper
                  spaceBetween={30}
                  loop={true}
                  autoplay={{ delay: 3500, disableOnInteraction: false }}
                  slidesPerView={1}
                  modules={[Autoplay]}
                >
                  {testimonials.map((item, idx) => (
                    <SwiperSlide key={idx}>
                      <div className="testimonial-item">
                        <div className="testimonial-rating">
                          {[...Array(5)].map((_, i) => (
                            <i key={i} className="fa-solid fa-star" />
                          ))}
                        </div>
                        <div className="testimonial-content">
                          <p>{item.text}</p>
                        </div>
                        <div className="testimonial-body">
                          <div className="author-image">
                            <i className="fa-solid fa-user" />
                          </div>
                          <div className="author-content">
                            <h3>{item.name}</h3>
                            <p>{item.location}</p>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
